//设备监控
const deviceMonitorEn = {
  deMonLang: {
    请输入站点名称搜索: 'Please enter the station name',
    暂无数据: 'No data available',
    主机: 'Master',
    从机: 'Slave',
    未知: 'Unknown',
    请输入系统名称搜索: 'Please enter the system name',

    数据分析: 'Data analysis',
    字段选择: 'Field selection',
    请选择字段: 'Please select a field',
    时间范围: 'Time frame',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    查询: 'Query',
    重置: 'Reset',
    查询结果: 'Query results',
    末次数据时间: 'Last data time',

    '时间范围只能选择1-7天': 'The time range can only be selected from 1-7 days',
    单体电压: 'Cell voltage',
    单体温度: 'Cell temperature',
    支路: 'Branch',
    消防探头: 'Fire probe'
  },
  //pcs
  pcsLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    故障复位: 'Fault reset',
    设备状态: 'Equipment status',
    运行: 'Operation',
    停机: 'Shutdown',
    运行状态: 'Running state',
    充电: 'Charging',
    放电: 'Discharging',
    待机: 'Standby',
    工作状态: 'Working condition',
    并网: 'On grid',
    离网: 'Off grid',
    并网状态: 'Grid connection status',
    正常: 'Normal',
    故障: 'Malfunction',
    故障状态: 'Fault status',
    手动: 'Manual operation',
    远程: 'Remote',
    控制模式: 'Control mode',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    当日充电量: 'Daily charging capacity',
    当日放电量: 'Daily discharge capacity',
    交流频率: 'AC frequency',
    总交流有功功率: 'Total AC active power',
    总交流无功功率: 'Total AC reactive power',
    总交流视在功率: 'Total AC apparent power',
    总交流功率因数: 'Total AC power factor',
    A相有功功率: 'A-phase active power',
    B相有功功率: 'B-phase active power',
    C相有功功率: 'C-phase active power',
    A相无功功率: 'A-phase reactive power',
    B相无功功率: 'Phase B reactive power',
    C相无功功率: 'C-phase reactive power',
    A相视在功率: 'A-phase apparent power',
    B相视在功率: 'Phase B apparent power',
    C相视在功率: 'Phase C apparent power',
    AB电压: 'AB voltage',
    BC电压: 'BC voltage',
    CA电压: 'CA voltage',
    AB电流: 'AB current',
    BC电流: 'BC current',
    CA电流: 'CA current',
    A相电压: 'A-phase voltage ',
    B相电压: 'B-phase voltage ',
    C相电压: 'C-phase voltage ',
    A相电流: 'A-phase current ',
    B相电流: 'B-phase current ',
    C相电流: 'C-phase current ',
    PCS模块温度: 'PCS module Temperature',
    PCS环境温度: 'PCS ambient temperature',
    PCS散热器温度: 'PCS radiator temperature',
    A1模块温度: 'A1 module Temperature',
    B1模块温度: 'B1 module Temperature',
    C1模块温度: 'C1 module Temperature',
    A2模块温度: 'A2 module Temperature',
    B2模块温度: 'B2 module Temperature',
    C2模块温度: 'C2 module Temperature',
    进风口温度: 'Air inlet temperature',
    出风口温度: 'Air outlet temperature',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    DCDC故障状态字: 'DCDC fault status word',
    支路一: 'Branch one',
    直流功率: 'DC power',
    直流电压: 'DC Voltage',
    直流电流: 'DC current',
    支路数据: 'Branch data',
    支路: 'Branch',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    确认提示: 'Confirmation tips',
    请确认是否下发故障复位指令该指令每30秒内只可下发一次: 'Please confirm whether to issue the fault reset instruction, this instruction can only be issued once every 30 seconds!',
    请选择时间: 'Please select a time!'
  },
  //电表
  eleLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    总有功功率: 'Total active power',
    无功功率: 'Reactive Power',
    视在功率: 'Apparent power',
    功率因数: 'Power Factor',
    A相有功功率: 'A-phase active power',
    B相有功功率: 'B-phase active power',
    C相有功功率: 'C-phase active power',
    A相电压: 'A-phase voltage ',
    B相电压: 'B-phase voltage ',
    C相电压: 'C-phase voltage ',
    A相电流: 'A-phase current ',
    B相电流: 'B-phase current ',
    C相电流: 'C-phase current ',
    电网频率: 'Grid frequency',
    电流互感器变比: 'Current transformer ratio',
    电压互感器变比: 'Potential transformer ratio',
    电量数据: 'Electricity data',
    类别: 'Category',
    总: 'Total',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    日正向总电能: 'Daily forward total electrical energy',
    日反向总电能: 'Daily total reverse energy',
    累计正向总电能: 'Accumulated total forward energy',
    累计反向总电能: 'Accumulated total reverse energy',
    累计正向总电能原始值: 'Accumulated total forward energy（Original value）',
    累计反向总电能原始值: 'Accumulated total reverse energy（Original value）',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //BMS
  bmsLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    充电: 'Charging',
    放电: 'Discharging',
    空闲: 'Idle',
    充放电状态: 'Charging and discharging status',
    正常: 'Normal',
    禁充: 'Prohibit charging',
    禁放: 'Prohibit discharge',
    待机: 'Standby',
    停机: 'Shutdown',
    堆状态: 'Stack  state',
    与PCS通信: 'Communicate with PCS',
    与EMS通信: 'Communicate with EMS',
    离线: 'Offline',
    设备数据: 'Equipment data',
    总电压: 'Total voltage',
    总电流: 'Total current',
    SOC: 'SOC',
    SOH: 'SOH',
    充电限制功率: 'Charging limit power',
    放电限制功率: 'Discharge limiting power',
    可充电量: 'Rechargeable capacity',
    可放电量: 'Dischargeable capacity',
    平均温度: 'Average temperature',
    平均电压: 'Average voltage',
    绝缘值: 'Insulation value',
    正极绝缘值: 'Positive insulation value',
    负极绝缘值: 'Negative insulation value',
    最高温度: 'Maximum temperature',
    簇: 'Cluster',
    组: 'Group',
    单体: 'Monomer',
    最低温度: 'Minimum temperature',
    最高电压: 'Max voltage',
    最低电压: 'Min voltage',
    簇状态: 'Cluster state',
    并网: 'On grid',
    离网: 'Off grid',
    并网状态: 'Grid connection status',
    电压: 'Voltage',
    电流: 'Current',
    功率: 'Power',
    主正接触器: 'Main positive contactor',
    断开: 'Open',
    闭合: 'Closed',
    主负接触器: 'Main negative contactor',
    高压箱温度: 'HVB Temp',
    故障状态字: 'faultStatusWord',
    单体电池: 'Single cell battery',
    请选择: 'Please select',
    序号: 'Serial Number',
    单位: 'Unit',
    最高: 'Max',
    最低: 'Min',
    均衡: 'Balancing',
    暂无数据: 'No data available',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    电池堆视图: 'Battery stack view',
    电池簇视图: 'Battery Cluster View',
    单体电池视图: 'Single Cell View',

    电池单体电压: 'Battery cell voltage',
    单体电压: 'Cell voltage',
    电池单体温度: 'Battery cell temperature',
    单体温度: 'Cell temperature',
    请选择时间: 'Please select a time!',
    直流脱扣:'Direct current trip',
    交流脱扣:'Alternating current trip',
    'BMS控制':'BMS control',
    'BMS 控制':'BMS control',
    BMS软件复位: 'BMS Software reset',
    '请确认是否下发该指令，指令每30秒内可下发一次！':'Please confirm whether to send the command, the command can be sent every 30 seconds!'
  },
  //空调
  airLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    运行: 'Operation',
    待机: 'Standby',
    工作状态: 'Working condition',
    停止: 'Stop',
    室内风机: 'Indoor fan',
    室外风机: 'Outdoor fan',
    未选配: 'Not selected',
    应急风机: 'Emergency fan',
    压缩机: 'Compressor',
    电加热: 'Electrical heating',
    排氢状态: 'Discharging hydrogen gas status',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    送风: 'Air supply',
    制冷: 'Refrigeration',
    制热: 'Heating up',
    除湿: 'Dehumidification',
    工作模式: 'Mode of work',
    故障状态: 'Fault status',
    故障: 'Malfunction',
    正常: 'Normal',
    设备数据: 'Equipment data',
    电流: 'Current',
    交流电压: 'AC voltage',
    直流电压: 'DC Voltage',
    盘管温度: 'Coil temperature',
    柜外温度: 'Outside cabinet temperature',
    柜内温度: 'Cabinet temperature',
    冷凝温度: 'Condensation temperature',
    融霜温度: 'Defrosting temperature',
    排气温度: 'Exhaust temperature',
    出风温度: 'Air outlet temperature',
    回风温度: 'Return air temperature',
    柜内湿度: 'Humidity inside the cabinet',
    制热开启温度: 'Heating start temperature',
    制热关闭温度: 'Heating off temperature',
    制冷开启温度: 'Cooling start temperature',
    制冷关闭温度: 'Cooling off temperature',
    高温告警温度: 'High temperature alarm temperature',
    低温告警温度: 'Low temperature alarm temperature',
    高湿告警点: 'High humidity alarm point',
    除湿开启温度: 'Dehumidification opening temperature',
    除湿关闭温度: 'Dehumidification closing temperature',
    除湿开启湿度: 'Dehumidification opening humidity',
    除湿关闭湿度: 'Dehumidification closing humidity',
    内风机转速: 'Internal fan speed',
    外风机转速: 'External fan speed',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    温度参数设置: 'Temperature parameter settings',
    '点击“确定”按钮前，请确认参数是否正确！': 'Before clicking the "OK" button, please confirm if the parameters are correct!',
    制冷启动温度: 'Cooling start temperature',
    制热启动温度: 'Heating start temperature',
    取消: 'Cancel',
    确定: 'Confirm',
    空调强控: 'Air conditioning strong control',
    强控模式下部分控制能力互斥无法同时开启: 'In strong control mode, some control capabilities are mutually exclusive and cannot be turned on at the same time!',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态:
      'If you need to cancel the strong control command, please select the automatic mode and apply it to restore to the automatic operation state',
    控制模式: 'Control mode',
    控制类别: 'Control category',
    清除强控指令并执行设备自动模式: 'Clear the strong control command and execute the device automatic mode',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    强控模式: 'Strong control mode',
    自动模式: 'Automatic mode',
    开机: 'Power on',
    关机: 'Power off',
    加热: 'Heating',
    制冷: 'Refrigeration',
    送风: 'Air supply',
    待机: 'Standby',
    请输入制冷启动温度: 'Please enter the cooling start temperature!',
    '制冷启动温度数字范围 -100 - 100': 'Cooling start temperature number range -100 - 100',
    小数点后不允许超过1位: 'No more than 1 digits are allowed after the decimal point',
    请输入制冷关闭温度: 'Please enter the cooling off temperature!',
    '制冷关闭温度数字范围 -100 - 100': 'Cooling off temperature number range -100 - 100',
    请输入制热启动温度: 'Please enter the heating start temperature!',
    '制热启动温度数字范围 -100 - 100': 'Heating start temperature number range -100 - 100',
    '制热关闭温度数字范围 -100 - 100': 'Heating off temperature number range -100 - 100',
    请输入高温告警温度: 'Please enter the overtemperature alarm temperature!',
    '高温告警温度数字范围 -100 - 100': 'High temperature alarm temperature number range -100 - 100',
    请输入低温告警温度: 'Please enter the lower alarm temperature!',
    '低温告警温度数字范围 -100 - 100': 'Low temperature alarm temperature number range -100 - 100',
    请选择时间: 'Please select a time!',
    提示: 'Hint',
    请确认是否应用空调温度参数: 'Please confirm if the air conditioning temperature parameter is applied!',
    应用: 'Application',
    取消: 'Cancel',
    '制冷启动温度 - 制冷关闭温度 ≥ 1': 'Cooling start temperature - Cooling off temperature ≥ 1',
    '制热关闭温度- 制热启动温度 ≥ 1': 'Heating off temperature - Heating start temperature ≥ 1',
    请选择控制类别: 'Please select a control class!',
    请选择控制模式: 'Please select control mode!'
  },
  //箱变
  boxLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    运行: 'Operation',
    故障: 'Malfunction',
    待机: 'Standby',
    工作状态: 'Working condition',
    合闸: 'Closing',
    分闸: 'Opening',
    高压分合闸状态: 'High voltage opening and closing status',
    就地: 'Local',
    远方: 'Distant',
    远方就地状态: 'Remote local status',
    设备数据: 'Equipment data',
    高压IA: 'High voltage IA',
    高压IB: 'High voltage IB',
    高压IC: 'High voltage IC',
    高压3IO: 'High voltage 3IO',
    低压: 'Low voltage',
    低压UAN: 'Low voltage UAN',
    低压UBN: 'Low voltage UBN',
    低压UCN: 'Low voltage UCN',
    低压UAB: 'Low voltage UAB',
    低压IA: 'Low voltage IA',
    低压IB: 'Low voltage IB',
    低压UBC: 'Low voltage UBC',
    低压UCA: 'Low voltage UCA',
    低压IC: 'Low voltage IC',
    低压3IO: 'Low voltage 3IO',
    低压频率: 'Low voltage frequency',
    低压有功功率: 'Low voltage active power',
    低压无功功率: 'Low voltage reactive power',
    温度: 'Temperature ',
    油温: 'Oil temperature',
    低压功率因数: 'Low voltage power factor',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //光伏
  phoLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    光伏强控: 'Photovoltaic strong control',
    设备复位: 'Device reset',
    设备状态: 'Equipment status',
    运行: 'Operation',
    停机: 'Shutdown',
    运行状态: 'Running state',
    初始化: 'Initialize',
    等待: 'Wait',
    正常: 'Normal',
    故障: 'Malfunction',
    烧录: 'Burn',
    并网: 'On grid',
    离网: 'Off grid',
    自检: 'Self check',
    工作状态: 'Working condition',
    故障状态: 'Fault status',
    与EMS通信: 'Communicate with EMS',
    离线: 'Offline',
    设备数据: 'Equipment data',
    日发电量: 'Daily power generation',
    功率因数: 'Power Factor',
    R相电压: 'R phase voltage',
    S相电压: 'S phase voltage',
    TR线电压: 'TR line voltage',
    直流电流: 'DC current',
    S相温度: 'S phase temperature',
    总发电量: 'Total power generation',
    电网频率: 'Grid frequency',
    S相电压: 'S phase voltage',
    T相电流: 'T phase current',
    RS线电流: 'RS line current',
    直流功率: 'DC power',
    T相温度: 'T phase temperature',
    RS线电压: 'RS line voltage',
    ST线电流: 'ST line current',
    直流电压: 'DC Voltage',
    环境温度: 'Environmental temperature',
    无功功率: 'Reactive Power',
    负极电压: 'Negative voltage',
    R相电流: 'R phase current',
    ST线电压: 'ST line voltage',
    TR线电流: 'TR line current',
    R相温度: 'R phase temperature',
    散热器温度: 'heatsink temperature',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    确认提示: 'Confirmation tips',
    请确认是否下发故障复位指令该指令每30秒内只可下发一次: 'Please confirm whether to issue the fault reset instruction, this instruction can only be issued once every 30 seconds!',
    强控模式下部分控制能力互斥无法同时开启: 'In strong control mode, some control capabilities are mutually exclusive and cannot be turned on at the same time!',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态:
      'If you need to cancel the strong control command, please select the automatic mode and apply it to restore to the automatic operation State!',
    控制模式: 'Control mode',
    控制类别: 'Control class',
    清除强控指令并执行设备自动模式: 'Clear the strong control command and execute the device automatic mode',
    强控模式: 'Strong control mode',
    自动模式: 'Automatic mode',
    关机: 'Power off',
    开机: 'Power on',
    请选择控制模式: 'Please select control mode!',
    请选择控制类别: 'Please select a control class!'
  },
  //消防
  fireLang: {
    消防开关控制: 'Fire switch control',
    开启: 'Open',
    关闭: 'Close',
    开: 'On',
    关: 'Off',
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    运行: 'Operation',
    待机: 'Standby',
    运行状态: 'Running state',
    故障码: 'Fault code',
    暂无: 'Not available',
    设备数据: 'Equipment data',
    CO浓度: 'CO concentration',
    氢气浓度: 'Hydrogen concentration',
    烟雾数值: 'Smoke value',
    VOC数值: 'VOC value',
    温度数值: 'Temperature value',
    报警等级: 'Alarm level',
    '1级报警': 'Level 1 alarm',
    '2级报警': 'Level 2 alarm',
    '3级报警': 'Level 3 alarm',
    '4级报警': 'Level 4 alarm',
    无故障: 'No fault',
    CO浓度报警: 'CO concentration alarm',
    氢气浓度报警: 'Hydrogen concentration alarm',
    VOC报警: 'VOC alarm',
    烟雾报警: 'Smoke alarm',
    温度报警: 'Temperature alarm',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!',
    是否确认开启消防: 'Are you sure to turn on fire protection?',
    提示: 'Hint',
    是否确认关闭消防: 'Are you sure to turn off the fire protection?'
  },
  //风扇
  fanLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    运行: 'Operation',
    待机: 'Standby',
    工作状态: 'Working condition',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    风扇: 'Fan',
    转速: 'Speed',
    温度: 'Temperature',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //tms
  tmsLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    TMS强控: 'TMS strong control',
    设备状态: 'Equipment status',
    空闲: 'Idle',
    准备启动: 'Ready to start',
    运行: 'Run',
    延时停机: 'Delayed shutdown',
    自检: 'Self check',
    告警: 'Give an alarm',
    TMS机组运行状态: 'TMS unit operating status',
    制冷: 'Refrigeration',
    加热: 'Heating',
    自循环: 'Self-looping',
    自动: 'Automatic',
    停机: 'Shutdown',
    TMS运行模式: 'TMS operating mode',
    正常: 'Normal',
    tms故障: 'Failure',
    故障状态: 'Fault status',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    出水温度: 'Water outlet temperature',
    进水温度: 'Inlet water temperature',
    控制模式: 'Control mode',
    水泵状态: 'Pump status',
    补水泵运行状态: 'Make up pump status',
    外风机状态: 'FanStatus',
    设备数据: 'Equipment data',
    TMS供液温度: 'TMS supply temperature',
    TMS回液温度: 'TMS supply pressure',
    TMS供液压力: 'TMS supply pressure',
    TMS回液压力: 'TMS return pressure',
    环境温度: 'Environmental temperature',
    TMS恒温方式预设温度: 'TMS constant temperature preset temperature',
    制热开启温度: 'Heating start temperature',
    制热关闭温度: 'Heating off temperature',
    制冷开启温度: 'Cooling start temperature',
    制冷关闭温度: 'Cooling off temperature',
    吸气温度: 'Suction temp',
    板换温度: 'Plate temp',
    冷凝盘管温度: 'Condensing temp',
    进出水压差值: 'Water pressure difference',
    高压侧压力值: 'High pressure',
    低压侧压力值: 'Low pressure',
    电子膨胀阀开度: 'Electronic expansion valve',
    交流供电电压: 'Ac power voltage',
    压缩机转速: 'Compressor speed',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    强控模式下部分控制能力互斥无法同时开启: 'In strong control mode, some control capabilities are mutually exclusive and cannot be turned on at the same time!',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态:
      'If you need to cancel the strong control command, please select the automatic mode and apply it to restore to the automatic operation state',
    控制类别: 'Control category',
    清除强控指令并执行设备自动模式: 'Clear the strong control command and execute the device automatic mode',
    取消: 'Cancel',
    确定: 'Confirm',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    请选择时间: 'Please select a time!',
    强控模式: 'Strong control mode',
    自动模式: 'Automatic mode',
    开机: 'Power on',
    关机: 'Power off',
    待机: 'Standby',
    请选择控制模式: 'Please select control mode!',
    请选择控制类别: 'Please select a control class!'
  },
  //外设
  exterLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    急停状态: 'Scram condition',
    正常: 'Normal',
    急停: 'Scram',
    消防触发: 'Fire triggered',
    消防状态: 'Fire status',
    温感状态: 'Thermal state',
    异常: 'Abnormal',
    门禁状态: 'Access control status',
    开启: 'Open',
    关闭: 'Close',
    浸水: 'Flooded',
    水浸状态: 'Flooded condition',
    烟感状态: 'Smoke sensing state',
    喷洒: 'Spray',
    消防喷洒: 'Fire spray',
    火灾: 'Fire',
    火灾状态: 'Fire status',
    故障: 'Malfunction',
    消防设备: 'Fire equipment',
    断路器: 'circuitBreaker',
    pcs状态信号: 'pcsStatusSignal', //缺失
    关机: 'Power off',
    送风: 'Air supply',
    柜体风机反馈: 'cabinetFanFeedback',
    辅电信号: 'Auxiliary signal',
    触发: 'Trigger',
    声光报警器: 'Audible and visual alarm',
    PCS触发信号: 'PCS trigger signal',
    门禁灯: 'Access control light',
    断路器驱动: 'Circuit breaker drive',
    空调干节点: 'Air conditioning dry node',
    消防干节点: 'Fire dry node',
    风扇继电器: 'Fan relay',
    显示屏控制: 'Display screen control',
    充电桩控制: 'Charging station control',

    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //除湿器
  moisLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    停止: 'Stop',
    运行中: 'In operation',
    工作状态: 'Working condition',
    控湿状态: 'Humidity control state',
    控温状态: 'Temperature control state',
    正常: 'Normal',
    故障: 'Malfunction',
    故障状态: 'Fault status',
    未运行: 'Not running',
    运行中: 'In operation',
    除霜状态: 'Defrost State',
    自动: 'Automatic',
    手动: 'Manual operation',
    控湿手自动模式: 'Humidity control hand automatic mode',
    控温手自动模式: 'Temperature control hand automatic mode',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    环境温度: 'Environmental temperature',
    外部温度传感器故障状态: 'External temperature sensor fault status',
    内部温度: 'Internal temperature',
    内部温度传感器故障状态: 'Internal temperature sensor fault status',
    温度启动值: 'Temperature startup value',
    温度关闭值: 'Temperature shutdown value',
    湿度: 'Humidity',
    湿度传感器故障状态: 'Humidity sensor fault status',
    除湿启动值: 'Dehumidification start-up value',
    除湿关闭值: 'Dehumidification shutdown value',
    控温方式: 'Temperature control mode',
    降温: 'Cooling',
    升温: 'Warming',
    风机故障状态: 'Fan fault status',

    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //ups
  upsLang: {
    UPS开关控制: 'UPS switch control',
    开启: 'Open',
    关闭: 'Close',
    放电测试: 'Discharge test',
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    UPS运行状态: 'UPS running state',
    关机: 'Power off',
    运行: 'Operation',
    上电状态: 'Power on',
    待机状态: 'Standby',
    旁路状态: 'bypass',
    市电工作状态: 'Working status of mains power',
    电池供电状态: 'Battery powered',
    测试自检放电状态: 'Test self check discharge status',
    故障状态: 'Fault status',
    转换器: 'Converter',
    经济状态: 'Economic status',
    关机状态: 'Shutdown',
    保留: 'Retain',
    UPS状态: 'UPS state',
    在线: 'Online',
    后备: 'Back-up',
    UPS类型: 'UPS type',

    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    不正常: 'Abnormal',
    市电状态: 'Mains power status',
    电池电压低: 'Low battery voltage',
    电池电压状态: 'Battery voltage status',
    故障: 'Malfunction',
    设备状态: 'Equipment status',
    设备数据: 'Equipment data',
    UPS温度: 'UPS temperature',
    电池维持时间: 'Battery maintenance time',
    直流电电池: 'Direct current (battery)',
    电池总压: 'Total battery voltage',
    电池温度: 'Battery temperature',
    容量: 'Capacity',
    电流: 'Current',
    额定信息: 'Rating Information',
    额定总功率: 'Total rated power',
    输入输出相数: 'Number of input and output phases',
    单进单出: 'Single in single out',
    三进单出: 'Three in one out',
    三进三出: 'Three in three out',
    额定输入电压种类: 'Type of rated input voltage',
    额定电池电压: 'Rated battery voltage',
    输出定额电压: 'Output rated voltage',
    输出定额电流: 'Output rated current',
    输出定额频率: 'Output rated frequency',
    额定电池节数: 'Rated number of cells',
    节: '',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!',
    提示: 'Hint',
    是否确认开启UPS: 'Confirm to start UPS?',
    是否确认关闭UPS: 'Confirm to close UPS?',
    是否开启放电测试: 'Discharge test on or off?'
  },
  //充电桩
  chargeLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    操作日志: 'Operation Log',
    充电桩控制: 'Charging station control',
    设备状态: 'Equipment status',
    运行: 'Operation',
    停机: 'Shutdown',
    运行状态: 'Running state',
    正常: 'Normal',
    离线: 'Offline',
    EMS通信状态: 'EMS communication status',
    待机: 'Standby',
    充电: 'Charging',
    充电结束: 'End of charge',
    故障: 'Malfunction',
    充电枪已连接: 'Charging gun connected',
    工作状态: 'Working condition',
    设备数据: 'Equipment data',
    累计充电电量: 'Cumulative charge capacity',
    充电电压: 'Voltage of charge',
    充电电流: 'Current of charge',
    充电功率: 'Power of charge',
    充电请求功率: 'Charge request power',
    最大允许充电功率: 'Maximum allowed charging power',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',

    请选择控制指令后点击确定以下发: 'Please select the control instruction and click "OK" to issue it!',
    控制指令: 'Control instructions',
    开机: 'Enable',
    关机: 'Disable',
    请选择时间: 'Please select a time!'
  },
  //环境监测
  envLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    环境温度: 'Environmental temperature',
    环境湿度: 'Environmental humidity',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //dcdc
  dcdcLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备状态: 'Equipment status',
    停机: 'Shutdown',
    运行: 'Operation',
    运行状态: 'Running state',
    恒流充放电: 'CC charging',
    恒压充放电: 'CV charging',
    恒功率充放电: 'CP charging',
    高压侧恒压: 'CHV',
    MPPT: 'MPPT',
    工作模式: 'Mode of work',
    正常: 'Normal',
    故障: 'Malfunction',
    故障状态: 'Fault status',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    设备数据: 'Equipment data',
    输入端电流: 'Input current',
    输出端电压: 'Output voltage',
    输出端电流: 'Output current',
    输入端功率: 'Input power',
    输出端功率: 'Output power',
    机内温度: 'Internal temperature',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',

    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    请选择时间: 'Please select a time!'
  },
  //柴发
  dieselLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    柴发控制: 'Diesel generator control',
    设备状态: 'Equipment status',
    停机: 'Shutdown',
    运行: 'Operation',
    运行状态: 'Running state',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    故障: 'Malfunction',
    故障状态: 'Fault status',
    报警: 'Alarm',
    告警状态: 'Alarm status',
    自动: 'Automatic',
    手动: 'Manual operation',
    测试: 'Test',
    engine工作状态: 'Engine working status',
    有效: 'Valid',
    无效: 'Invalid',
    机组状态: 'Gen status',
    市电状态: 'Mains power status',
    分闸: 'Opening',
    合闸: 'Closing',
    机组断路器状态: 'Gen breaker status',
    市电断路器状态: 'Mains breaker status',
    设备数据: 'Equipment data',
    发动机油压: 'Oil pressure',
    发动机水温: 'Coolant temperature',
    发动机燃油油位: 'Fule level',
    充电发电机电压: 'Charge alternator voltage',
    蓄电池电压: 'Engine Battery voltage',
    发动机转速: 'Engine speed ',
    发动机运行时间: 'Engine run time',
    秒: '秒',
    启动次数: 'Number of starts',
    发电机总有功功率: 'Engine total active power',
    发电机总无功功率: 'Engine total reactive power',
    发电机总视在功率: 'Engine total apparent power',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    请选择控制指令后点击确定以下发: 'Please select the control instruction and click "OK" to issue it!',
    控制指令: 'Control instructions',
    开机: 'Enable',
    关机: 'Disable',
    取消: 'Cancel',
    确定: 'Confirm',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    请选择时间: 'Please select a time!'
  },
  //综合保护
  integratedLang: {
    末次数据时间: 'Last data time',
    数据分析: 'Data analysis',
    数据导出: 'Data export',
    设备复位: 'Device reset',
    设备状态: 'Equipment status',
    正常: 'Normal',
    离线: 'Offline',
    与EMS通信: 'Communicate with EMS',
    故障: 'Malfunction',
    事故总信号: 'Accident overall signal',
    过流I段跳闸: 'Overcurrent section I trip',
    过流II段跳闸: 'Overcurrent section II trip',
    过流III段跳闸: 'Overcurrent section III trip',
    过流I段压板: 'Overcurrent section I pressure plate',
    过流II段压板: 'Overcurrent section II pressure plate',
    过流III段压板: 'Overcurrent section III pressure plate',
    设备数据: 'Equipment data',
    A相电流: 'A-phase current',
    B相电流: 'B-phase current',
    C相电流: 'C-phase current',
    A相电压: 'A-phase voltage',
    B相电压: 'B-phase voltage',
    C相电压: 'C-phase voltage',
    有功功率: 'Active power',
    无功功率: 'Reactive Power',
    设备故障字: 'Equipment fault word',
    故障状态字: 'faultStatusWord',
    起止时间: 'Beginning and ending time',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    取消: 'Cancel',
    确定: 'Confirm',
    提示: 'Hint',
    请确认是否下发设备复位指令: 'Please confirm whether to issue the device reset instruction!',
    请选择时间: 'Please select a time!'
  },
  //操作日志
  operationLog: {
    设备监控: 'Equipment monitoring',
    充电桩: 'Charging station',
    操作日志: 'Operation Log',
    时间范围: 'Time frame',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    开始月份: 'Starting month',
    结束月份: 'End month',
    开始年份: 'Starting year',
    结束年份: 'End year',
    查询: 'Query',
    重置: 'Reset',
    时间: 'Time',
    操作内容: 'Operation content',
    操作结果: 'Operation result',
    操作账号: 'Operation account',
    失败: 'Fail',
    成功: 'Success'
  },
  atslang: {
    EMS通讯: 'EMS communication',
    常用电源状态: 'Common power conn state',
    备用电源状态: 'Standby power conn state',
    '常用电源 A 相电压': 'A phase voltage of common power supply',
    '常用电源 B 相电压': 'B phase voltage of common power supply',
    '常用电源 C 相电压 V': 'C phase voltage of common power supply',
    常用电源频率: 'Common power supply frequency',
    '备用电源 A 相电压': 'Standby power supply phase A voltage',
    '备用电源 B 相电压': 'Standby power supply phase B voltage',
    '备用电源 C 相电压': 'Standby power supply phase C voltage',
    备用电源频率: 'Standby power frequency'
  }
}
export default deviceMonitorEn
